// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ArrowRight: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 10 19" enableBackground="new 0 0 10 19" xmlSpace="preserve" fill="currentColor">
<path fillRule="evenodd" clipRule="evenodd" d="M0.5,15.93L6.84,9.5L0.5,3.02V0.5l9,9l-9,9V15.93z"/>
</svg>;
};

export default React.memo(ArrowRight);
